import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CampaignTrackingService} from '@app/services/campaign-tracking.service';
import {isPlatformBrowser} from '@angular/common';
import {CrmAccountTrackingService} from '@app/services/crm-account-tracking.service';

@Injectable()
export class DataTrackingInterceptor implements HttpInterceptor {
  private platformId = inject(PLATFORM_ID);
  private campaignTrackingService = inject(CampaignTrackingService);
  private customerIdTrackingService = inject(CrmAccountTrackingService);
  private hasInitialized = false;

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.hasInitialized) {
      this.hasInitialized = true;
      this.setupTracking();
    }
    return next.handle(request);
  }

  setupTracking() {
    if (!isPlatformBrowser(this.platformId)) return

    this.campaignTrackingService.setupCampaignTracking();
    this.customerIdTrackingService.setUpTrackingForAllParameters();
  }
}
